// extracted by mini-css-extract-plugin
module.exports = {"close":"truckingCompanyModal_close__WBDsy","title":"truckingCompanyModal_title__1R_GY","dialogContent":"truckingCompanyModal_dialogContent__2BAdB"};